/**
 * Helper to get environment variables from runtime config or build-time env
 * Runtime config (window.REACT_APP_CONFIG) takes precedence over build-time env vars
 */
export const getEnvVar = (key: string, defaultValue?: string): string | undefined => {
	try {
		// Check runtime config first (for production deployments)
		if (typeof window !== 'undefined' && (window as any).REACT_APP_CONFIG) {
			const runtimeValue = (window as any).REACT_APP_CONFIG[key];
			if (runtimeValue && typeof runtimeValue === 'string' && !runtimeValue.startsWith('__') && !runtimeValue.endsWith('__')) {
				return runtimeValue;
			}
		}
		// Fallback to build-time env vars (for development)
		return process.env[key] || defaultValue;
	} catch (error) {
		console.error(`Error getting env var ${key}:`, error);
		return defaultValue;
	}
};

export const getEnvVarAsBoolean = (key: string, defaultValue = false): boolean => {
	try {
		const value = getEnvVar(key);
		if (!value || typeof value !== 'string') return defaultValue;
		return value.toLowerCase() === 'true';
	} catch (error) {
		console.error(`Error getting boolean env var ${key}:`, error);
		return defaultValue;
	}
};

